import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ActiviteService } from '../../../../services/activite/activite.service';
import { ActivtieResponse } from '../../../../data/http/responses/activite.response';
import { routeAlias } from '../../../../../routesalias';
import { AppService } from '../../../../core/app.service';
import { UiTable } from "../../../../components/ui/table/table.component";
import { TableActivites } from '../../../../data/schemas/table.schema';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { LoaderComponent } from "../../../../components/ui/loader/loader.component";
import { SelectComponent } from '../../../../components/forms/select/select.component';
import { SelectOption } from '../../../../data/schemas/selectoption.schema';
import { StructureProgrammatiqueResponse } from '../../../../data/http/responses/structureprogrammatique.res';
import { StructureProgammatiqueService } from '../../../../services/structureProgrammatiquesService';
import { TypeInterventionService } from '../../../../services/typeintervention/typeintervention.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TypeInterventionResponse } from '../../../../data/http/responses/typeintervention.response';
import { Subscription } from 'rxjs';
import { UiButtonComponent } from '../../../../components/button/button.component';
import { loaderIntervantion } from "../../../../components/ui/loaderIntervantion/loaderIntervantion.component";
import { ConfirmDialogComponent } from '../../../../components/ui/Confirmdialog/Confirmdialog.component';
@Component({
  selector: 'app-activity',
  imports: [RouterLink, UiTable, NgIf, MatIcon, ReactiveFormsModule, SelectComponent, LoaderComponent, UiButtonComponent, loaderIntervantion, ConfirmDialogComponent],
  templateUrl: './activity.component.html',
  styleUrl: './activity.component.scss'
})
export class ActivityChildPage implements OnInit {

  public tableActivities = TableActivites
  public activities: ActivtieResponse[] = [];
  public activitiesFiltre: ActivtieResponse[] = [];
  public routealias = routeAlias;
  public isLoading: boolean = false;
  public structures: StructureProgrammatiqueResponse[] = [];
  public typeInterventionData: TypeInterventionResponse[] = [];

  private subscription: Subscription = new Subscription()
  public resultatStructures: SelectOption[] = [];
  public types: SelectOption[] = [];

  public generaleForm: FormGroup = new FormGroup({});
  // Delete dialog state
  public showDeleteDialog: boolean = false;
  public itemToDelete: any = null;
  public isDeleteLoading: boolean = false;

  public loadingtypeSelect = false;
  public loadinginterventionSelect = false;

  public programmes: SelectOption[] = [];
  private programmeStructures: StructureProgrammatiqueResponse[] = [];
  private usingProgrammeFallback = false;
  public currentDescendants: any[] = [];
  public loadingProgrammeSelect = false;

  constructor(
    private activiteService: ActiviteService,
    private structureProgrammatiqueService: StructureProgammatiqueService,
    private typeInterventionService: TypeInterventionService,
    private fb: FormBuilder,
    private AppService: AppService
  ) {

    this.generaleForm = this.fb.group({
      programmeSelect: ['', Validators.required],
      typeCodeSelect: ['', Validators.required],
      interventionSelect: ['', Validators.required]
    });

  }

  loadProgrammes(): void {
    this.loadingProgrammeSelect = true;
    this.structureProgrammatiqueService.getAllByAppId(this.AppService.getAppId()).subscribe({
      next: (response: any) => {
        this.programmeStructures = (response.data || []) as StructureProgrammatiqueResponse[];
        this.programmes = this.programmeStructures.map(item => ({ value: item.id, label: item.titre }));
        this.useProgrammesAsFallbackIfNeeded();
        this.loadingProgrammeSelect = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des programmes :', error);
        this.loadingProgrammeSelect = false;
      }
    });
  }


  translateToTypeActivite(type: any): void {
    this.resultatStructures = this.currentDescendants
      .filter((n: any) => n.typeActivite === type)
      .map((item: any) => ({ value: item.id, label: item.titre }));
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.loadActivities();
    this.loadProgrammes(); // old this.loadStructures();
    this.loadTypeIntervention();

    // Utiliser .add() pour gérer plusieurs souscriptions avec un seul objet Subscription
    // //console.log("Dans le ngOnInit : subscription au changement de type d'activité")
    this.subscription.add(
      this.generaleForm.get('typeCodeSelect')?.valueChanges.subscribe(selectedId => {
        //console.log("Type d'activité sélectionné dans le formulaire :" + selectedId);
        if (selectedId) {
          this.translateToTypeActivite(selectedId);
        }
      })
    );

    this.subscription.add(
      this.generaleForm.get('programmeSelect')?.valueChanges.subscribe(programmeId => {
        this.currentDescendants = [];
        this.resultatStructures = [];
        this.generaleForm.patchValue({ typeCodeSelect: '', interventionSelect: '' }, { emitEvent: false });
        this.activitiesFiltre = programmeId ? this.activities : [];
        if (!programmeId) return;
        this.structureProgrammatiqueService.getAllDescendants(this.AppService.getAppId(), programmeId).subscribe({
          next: (response: any) => {
            this.currentDescendants = this.flattenDescendants(this.getStructureNodes(response.data));
            this.applyActivityFilter();
          },
          error: (e) => console.error('Erreur récupération descendants du programme :', e)
        });
      })
    );

    this.subscription.add(
      this.generaleForm.get('interventionSelect')?.valueChanges.subscribe(selectedId => {
        this.applyActivityFilter();
      })
    );
  }

  private flattenDescendants(nodes: any[], parentId: string | null = null): any[] {
    return nodes.flatMap(node => {
      const current = { ...node, parent: node.parent ?? parentId };
      const children = Array.isArray(node.enfant) ? node.enfant : [];
      return [current, ...this.flattenDescendants(children, this.toId(node.id))];
    });
  }

  private getStructureNodes(data: any): any[] {
    if (Array.isArray(data)) return data;
    if (data?.descendants) return this.getStructureNodes(data.descendants);
    if (data?.enfant) return [data];
    return data ? [data] : [];
  }

  private applyActivityFilter(): void {
    const programmeId = this.toId(this.generaleForm.get('programmeSelect')?.value);
    const interventionId = this.toId(this.generaleForm.get('interventionSelect')?.value);

    if (!programmeId) {
      this.activitiesFiltre = this.usingProgrammeFallback ? [...this.activities] : [];
      return;
    }

    if (!interventionId) {
      if (this.usingProgrammeFallback) {
        this.activitiesFiltre = this.activities.filter(activity =>
          this.toId(activity.id) === programmeId
        );
        return;
      }
      this.activitiesFiltre = this.activities.filter(activity =>
        this.currentDescendants.some(node => this.toId(node.id) === this.getActivityParentId(activity))
      );
      return;
    }

    const selectedIds = new Set([
      interventionId,
      ...this.currentDescendants
        .filter(node => this.isDescendantOf(node, interventionId))
        .map(node => this.toId(node.id))
    ]);

    this.activitiesFiltre = this.activities.filter(activity =>
      selectedIds.has(this.getActivityParentId(activity)) || selectedIds.has(this.toId(activity.id))
    );
  }

  private getActivityParentId(activity: ActivtieResponse): string {
    return this.toId((activity as any).parentId ?? activity.parent ?? (activity as any).typeInterventionSelect);
  }

  private isDescendantOf(node: any, ancestorId: string): boolean {
    let parentId = this.toId(node.parent);
    const visited = new Set<string>();

    while (parentId && !visited.has(parentId)) {
      if (parentId === ancestorId) return true;
      visited.add(parentId);
      const parentNode = this.currentDescendants.find(item => this.toId(item.id) === parentId);
      parentId = this.toId(parentNode?.parent);
    }

    return false;
  }

  private toId(value: any): string {
    if (value && typeof value === 'object') return String(value.id ?? '');
    return String(value ?? '');
  }

  private useProgrammesAsFallbackIfNeeded(): void {
    if (this.activities.length > 0 || this.programmeStructures.length === 0) return;

    this.activities = this.programmeStructures.map(programme => ({
      ...programme,
      titre: programme.titre,
      parent: programme.parent ?? null,
      taches: [],
      dateCreation: programme.dateDebut ?? ''
    } as ActivtieResponse));
    this.usingProgrammeFallback = true;
    this.activitiesFiltre = [...this.activities];
    if (this.generaleForm.get('programmeSelect')?.value) {
      this.applyActivityFilter();
    }
  }

  hasAccess(roles?: string[]): boolean {
    if (!roles || roles.length === 0) return true;
    // Utilise le même service que la sidebar
    if (this.AppService['authService'] && typeof this.AppService['authService'].hasAnyRole === 'function') {
      const result = this.AppService['authService'].hasAnyRole(roles);
      try {
        //console.debug('ExpressionBesoin.hasAccess check', { required: roles, userRoles: this.AppService['authService'].getUserRoles(), allowed: result });
      } catch (e) { }
      return result;
    }
    return false;
  }


  private flattenStructures(structures: StructureProgrammatiqueResponse[], parentId: string | null = null): StructureProgrammatiqueResponse[] {
    let flattened: StructureProgrammatiqueResponse[] = [];
    for (const structure of structures) {
      // Créer un nouvel objet pour éviter de modifier la structure originale si elle est immuable
      const currentStructure: StructureProgrammatiqueResponse = { ...structure, parent: parentId };
      flattened.push(currentStructure);
      if (structure.enfant && structure.enfant.length > 0) {
        flattened = flattened.concat(this.flattenStructures(structure.enfant, structure.id));
      }
    }
    return flattened;
  }


  private flattenStructuresWithId(structures: StructureProgrammatiqueResponse[], parentId: string | null = null): StructureProgrammatiqueResponse[] {
    let flattened: StructureProgrammatiqueResponse[] = [];
    for (const structure of structures) {
      // Créer un nouvel objet pour éviter de modifier la structure originale si elle est immuable
      const currentStructure: StructureProgrammatiqueResponse = { ...structure, parent: parentId };
      flattened.push(currentStructure);
      if (structure.enfant && structure.enfant.length > 0) {
        flattened = flattened.concat(this.flattenStructures(structure.enfant, structure.id));
      }
    }
    return flattened;
  }

  loadTypeIntervention(): void {
    this.loadingtypeSelect = true;
    this.typeInterventionService.getAllByAppId(this.AppService.getAppId()).subscribe({
      next: (response: any) => {
        this.typeInterventionData = response.data;
        this.types = this.typeInterventionData
          .filter((item: TypeInterventionResponse) => item.id !== 'PROGRAMME')
          .map((item: TypeInterventionResponse) => ({ value: item.id, label: item.libelle }));
        this.loadingtypeSelect = false;

        //this.setLowestLevelTypeIntervention();
      },
      error: (error) => {
        console.error('Erreur lors du chargement des types intervention :', error);
        this.loadingtypeSelect = false;
      }
    });
  }

  loadStructures(): void {
    this.loadinginterventionSelect = true;
    this.structureProgrammatiqueService.getAllByAppId(this.AppService.getAppId()).subscribe({
      next: (response: any) => {
        // Supposons que response.data est un tableau de structures de niveau supérieur avec des 'enfant' imbriqués
        this.structures = this.flattenStructures(response.data); // Aplatir et ajouter les ID des parents
        //console.log("Structures chargées :", this.structures);

        /*this.loadTypeIntervention();
        this.translateToTypeActivite();

        // Après le chargement des structures, vérifier si nous avons une valeur dans le formulaire
        const interventionSelectValue = this.generaleForm.get('interventionSelect')?.value;
        if (interventionSelectValue) {
          this.findHierarchy(interventionSelectValue);
        } */
        this.loadinginterventionSelect = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
        this.loadinginterventionSelect = false;
      }
    });
  }

  // Méthode pour obtenir le label du type sélectionné
  getTypeLabel(): string {
    const selectedValue = this.generaleForm.get('typeCodeSelect')?.value;
    if (selectedValue) {
      const selectedType = this.types.find(t => t.value === selectedValue);
      return selectedType?.label || 'Parent';
    }
    return 'Parent';
  }

  loadActivities(): void {
    this.isLoading = true
    this.activiteService.getAllByAppIdExcludeRegroupement(this.AppService.getAppId()).subscribe({
      next: (response) => {
        const activities = (response.data || []) as ActivtieResponse[];
        this.activities = activities;
        if (activities.length === 0) {
          this.useProgrammesAsFallbackIfNeeded();
        } else {
          this.usingProgrammeFallback = false;
          this.activitiesFiltre = [...this.activities];
        }
        this.isLoading = false
      },
      error: (error) => {
        console.error("Erreur lors du chargement des activités", error);
        this.isLoading = false
      }
    })
  }

  getEditRouterLink(item: any): (string | number)[] {
    // Check if the item is a regroupement
    //console.log(item)
    if (item.regroupements && item.regroupements.length > 0) {
      return [
        '/',
        this.routealias.activities.home,
        this.routealias.activities.activity.home,
        this.routealias.activities.activity.regroupement_activity.home,
        this.routealias.activities.activity.regroupement_activity.edit,
        item.id
      ];
    }
    else if (item.activites && item.activites.length > 0) {
      return [
        '/',
        this.routealias.activities.home,
        this.routealias.activities.activity.home,
        this.routealias.activities.activity.edit,
        item.id
      ];
    }
    else {
      return [
        '/',
        this.routealias.activities.home,
        this.routealias.activities.activity.home,
        this.routealias.activities.activity.edit,
        item.id
      ];
    }
  }

  onDelete(item: any): void {
    // Delete immediately (used by confirm handler)
    this.isDeleteLoading = true;
    this.activiteService.delete(item.id).subscribe({
      next: () => {
        this.loadActivities();
        this.isDeleteLoading = false;
        this.closeDeleteDialog();
      },
      error: (error) => {
        console.error('Erreur lors de la suppression de l\'activité:', error);
        this.isDeleteLoading = false;
        this.closeDeleteDialog();
      }
    });
  }

  openDeleteDialog(item: any): void {
    this.itemToDelete = item;
    this.showDeleteDialog = true;
  }

  closeDeleteDialog(): void {
    this.showDeleteDialog = false;
    this.itemToDelete = null;
    this.isDeleteLoading = false;
  }

  onDeleteConfirmed(): void {
    if (!this.itemToDelete) return;
    this.onDelete(this.itemToDelete);
  }
}